




interface Filter {
    slug: string;
    name: string;
    selected: boolean;
}


interface BlockGrid extends HTMLElement {
    filters: Array<Filter>;
    blocks: NodeListOf<HTMLElement>;
    resultCount: HTMLElement;
    descriptionHolder: HTMLElement;
    descriptions: NodeListOf<HTMLElement>;
}





class BlockGrid extends HTMLElement {

    constructor () {
        super();

        // Setup filters
        this.filters = this.filtersAttribute;

        const filterLabels : Array<HTMLElement> = this.filters.map(filter => this.createFilterLabel(filter));

        const filterGroup = document.createElement('section');
        filterGroup.classList.add('filter-group');
        filterGroup.append(...filterLabels);
        
        if ( filterLabels.length > 0 ) {
            this.append(filterGroup);
        }



        // Setup brands
        this.blocks = this.querySelectorAll('.block');

        const blockGroup = document.createElement('section');

        if ( filterLabels.length > 0 ) {
            this.resultCount = document.createElement('section');
            this.resultCount.classList.add('result-count');

            this.setupResultCountText();

            blockGroup.append(this.resultCount);
        }

        blockGroup.classList.add('block-group');
        blockGroup.append(...this.blocks);

        this.append(blockGroup);





        this.descriptionHolder = this.querySelector('.descriptions');
        this.descriptions = this.querySelectorAll('.descriptions .description');



        this.setBlockVisibility();
    }



    get filtersAttribute () : Array<Filter> {
        return JSON.parse(this.getAttribute('filters') || '[]');
    }


    get selectedFilters () : Array<Filter> {
        return this.filters.filter(f => f.selected);
    }


    get inactiveBlocks () : Array<HTMLElement> {
        return [...this.blocks]
            .filter(block => !this.hasActiveFilter(block));
    }

    get activeBlocks () : Array<HTMLElement> {
        return [...this.blocks]
            .filter(block => this.hasActiveFilter(block));
    }


    get inactiveDescriptions () : Array<HTMLElement> {
        return [...this.descriptions]
            .filter(desc => !this.hasSelectedFilter(desc));
    }



    setupResultCountText () {
        const resultCount = this.activeBlocks.length;
        const resultText = resultCount > 1 ? 'resultaten' : 'resultaat';
        if ( this.resultCount ) {
            this.resultCount.innerHTML = `${resultCount} ${resultText} gevonden`;
        }
    }

    // Check if element is in selected filter
    hasActiveFilter ( elem : HTMLElement ) : Boolean {
        return this.selectedFilters
            .every( (f : Filter) =>
                elem.dataset.filter.indexOf(f.slug) !== -1
            );
    }

    // Check if element is in selected filter
    hasSelectedFilter ( elem : HTMLElement ) : Boolean {
        return this.selectedFilters
            .some( (f : Filter) =>
                elem.dataset.filter.indexOf(f.slug) !== -1
            );
    }


    // Toggle filter selected
    toggleFilter (filter : Filter) : void {
        this.filters = this.filters.map(f => {
            if ( f === filter ) {
                f.selected = !f.selected;
            }

            return f;
        });
    }


    // Only show active brands
    setBlockVisibility () : void {
        // Show all elements
        this.blocks
            .forEach(block => block.classList.remove('hidden'));

        this.descriptions
            .forEach(desc => desc.classList.add('hidden'));
    

        // Hide elements of there are selected filters
        if ( this.selectedFilters.length > 0 ) {
            this.inactiveBlocks
                .forEach(block => block.classList.add('hidden'));

            this.descriptions
                .forEach(desc => desc.classList.remove('hidden'));

            this.inactiveDescriptions
                .forEach(desc => desc.classList.add('hidden'));

            if ( this.descriptionHolder ) {
                this.descriptionHolder.classList.remove('hidden');
            }
        } else {
            if ( this.descriptionHolder ) {
                this.descriptionHolder.classList.add('hidden');
            }
        }

        this.setupResultCountText();
    }



    // Setup clickable label
    createFilterLabel (filter : Filter) : HTMLElement {
        const label = document.createElement('label');
        label.classList.add('filter', 'button', 'white');
        label.append(filter.name);

        label.addEventListener('click', () => {
            label.classList.toggle('active');

            this.toggleFilter(filter);
            this.setBlockVisibility();
        });

        return label;
    }
}



export function setupBlockGrid () {
    customElements.define('block-grid', BlockGrid);
}
